<template>
    <nav class="FilterNav">
        <ul
            v-if="categories"
        >
            <strong
                v-if="heading"
                class="heading text--blue mr-small"
            >
                {{ heading }}
            </strong>
            <li
                v-for="(cat, index) in categories"
                :key="index"
                :class="{'is-active' : active == cat}"
            >
                <input
                    type="radio"
                    :value="cat"
                    v-model="active"
                />
                <label> {{ cat }}</label>
            </li>
        </ul>
        <slot />
    </nav>
</template>
<script>
export default {
    name: 'FilterNav',
    data() {
        return {
            active: this.activeFilter
        }
    },
    props: {
        categories: {
            type: Array,
            default: null
        },
        activeFilter: {
            type: String
        },
        heading: {
            type: String,
            default: null
        }
    },
    watch: {
        active() {
            this.$emit('update:activeFilter', this.active)
        },
        activeFilter() {
            this.active = this.activeFilter
        }
    }
}
</script>
<style lang="scss" scoped>

    .FilterNav {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: getSpacing('medium');
        z-index: 3;
        position: relative;

        @include media-query(palm) {
            margin-bottom: getSpacing('medium');
            margin-left: -1.5rem;
            margin-right: -1.5rem;
        }
    }

    ul {
        display: flex;
        align-items: center;
        justify-content: center;

        @include media-query(palm) {
            justify-content: flex-start;
            position: absolute;
            overflow-x: auto;
            width: 100%;
            background: $action-color;
            color: getColor('white');
            padding: getSpacing('small') 0;
        }
    }

    li {
        position: relative;
        margin: 0 0.5rem;
        text-transform: uppercase;
        border-radius: 21px;
        font-weight: 700;
        font-size: 0.7rem;
        padding: 10px 14px;
        transition: all ease-out 0.235s;
        opacity: 1;

        &:hover {
            opacity: 0.8;
        }

        &.is-active {
            color: getColor('white');
            background: getColor('lightblue')
        }

        input {
            position: absolute;
            width: 100%;
            opacity: 0;
            cursor: pointer;
        }
    }

    .BaseButton {
        display: inline-block;
        margin-left: 0.5rem;
        width: 80px;
        padding-left: 0;
        padding-right: 0;

    }

    .FilterNav--listing {
        justify-content: space-between;

        @include media-query(palm) {
            margin-left: 0;
            margin-right: 0;
            margin-bottom: 0
        }

        .heading {
            margin-bottom: 5px;
            padding: 10px 0;
            font-size: 14px;
        }

        ul {
            justify-content: flex-start;
            flex-wrap: wrap;

            @include media-query(palm) {
                position: static;
                background: transparent;
                color: unset;
            }
        }

        li {
            max-width: 230px;
            margin-right: 0.7rem;
            margin-left: 0;
            margin-bottom: 5px;

            &:not(.is-active) {
                padding-left: 0;
                padding-right: 0;
                margin-right: 1.4em;
            }
        }
    }
</style>
